import { Separator, Text, ThemeProvider } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

import { MIN_SIGNERS } from '../../constants';
import { useRecentSignersConnection } from '../../hooks/useRecentSignersConnection';
import { AccessibleDescription } from '../AccessibleDescription';
import { ActivityPill, ActivityScroller } from '../ActivityScroller';

export const RecentSignersViewportNormal: React.FC = () => {
	const recentSigners = useRecentSignersConnection();

	if (recentSigners.length < MIN_SIGNERS) {
		return null;
	}

	return (
		<ThemeProvider>
			<div data-testid="recent-signers-desktop" className="mt-10 lg:ml-8">
				<div className="mb-4">
					<Text fontWeight="bold" size="small">
						<Translate value="corgi.petition_gamma.recent_signers.title" />
					</Text>
				</div>
				{
					// Make this the containing block for the gradient overlay:
				}
				<div className="relative">
					<ActivityScroller aria-hidden>
						{recentSigners.map((signer, index) => (
							<ActivityPill
								key={signer.id}
								title={signer.displayName}
								time={signer.createdAtRelativeLocalized}
								className={index === 0 ? 'ml-0' : 'ml-4'}
							/>
						))}
					</ActivityScroller>

					<AccessibleDescription />

					<div
						className="pointer-events-none absolute top-0 h-full w-full"
						// eslint-disable-next-line react/forbid-dom-props
						style={{ background: 'linear-gradient(to right, transparent 80%, white)' }}
					/>
				</div>
			</div>
			<Separator role="presentation" className="mt-8" />
		</ThemeProvider>
	);
};
